import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OperacionesService {
  baseUrl = environment.apiResrURL;
  estadisticasUrl = `${this.baseUrl}/sgi-estadisticas`;
  
  constructor (private http: HttpClient) { }

  public nuevaVisita(): Observable<any>{
    return this.http.get<any>(`${this.estadisticasUrl}/visita`);
  }
}
